<template>
    <!-- この商品をチェックした方はこんな商品もおすすめです！-->
    <div v-if="getLengthObj(pt300Init.relationList) > 0" class="history mb32 pt300">
        <h3>{{$t('pt300.labels.checkedMsg[0]')}}</h3>
        <div class="history-inner">
            <Carousel :perPageCustom="perPageCustom" :autoplay="true" :navigationEnabled="false" :loop="true" :autoplayTimeout="4000">
                <slide v-for="(item, index) in pt300Init.relationList" :key="index">
                    <router-link :to="{ name: SiteConstants.PG030 , params: {pageNo: 3, sItemNo: item.S_ITEM_NO}}"> 
                        <!-- 関連商品 -->
                        <img style="width: 86px; height: 86px;" :src="item.IMG_URL1" @error="getErrImage" :alt="$t('pt300.labels.productOrther')">
                    </router-link>
                </slide>
            </Carousel>
        </div><!-- /.history-inner -->
    </div><!-- /.history mb32 -->
</template>
<script>
import axios from "assets/js/request";
import common from "assets/js/common";
import SiteConstants from 'assets/const/SiteConstants.json';
import { Carousel, Slide } from 'vue-carousel';

export default {
    name: "PT300RelationParts",
    props:{
        ptInitData: {
            type: Object,
            default: null,
        },
    },
    components:{
        Carousel,
        Slide
    },
    data() {
        return {
            EC_IMG_ICONS: 'icons/',
            pt300Init:{
                relationList:[]
            },
            pt300ReqModel:{

            },
            SiteConstants: SiteConstants,
            site: "",
            perPageCustom: [
                [500,7],
                [0,4]
            ]
        }
    },
    mounted() {
        var _this = this;
        _this.site = _this.$router.history.current.fullPath.split("/")[1];

        if (_this.ptInitData){
            _this.pt300Init = _this.ptInitData;
            _this.perPageCustom[0] = [500,_this.pt300Init.pcNum];
            _this.perPageCustom[1] = [0,_this.pt300Init.spNum];
        }else{
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT300 + _this.$UrlConstants.DO_INIT, _this.pt300ReqModel).then(function(response) {
                //set data init
                _this.pt300Init = response.data;
                _this.perPageCustom[0] = [500,_this.pt300Init.pcNum];
                _this.perPageCustom[1] = [0,_this.pt300Init.spNum];

            }).catch(function(error) {
                common.errorAPI(error);
            });
        }
    },
    methods: {
        /**
         * exec load url default when load main image is error
         * @param {Any} event, event exec error
         */
        getErrImage(event) {
            //get image default
            event.target.src = common.getImgDefault();
        },
        /*
        * format price
        */
        formatPrice: function(value){
            return common.formatPrice(value);
        },
        /*
        * goto pg030
        */
        gotoPg030: function(sItemNo){
            this.$router.push({ name: this.SiteConstants.PG030, params :{pageNo: 3, sItemNo: sItemNo}});
        },
        /*
        * Get length obj
        */
        getLengthObj: function(obj) {
            if(obj != undefined)
            return common.getLengthObj(obj);
        },
        /**
         * Reload page
         */
        reload: function() {
            this.$router.go(0);
        },
    },
    created(){
        var _this = this;
        // Get data from params and query
        var paramData = _this.$route.params;
        var queryData = _this.$route.query;

        if(Object.keys(paramData).length > 0){
            _this.pt300ReqModel = Object.assign({}, _this.pt300ReqModel, paramData);
        }

        if(Object.keys(queryData).length > 0){
            _this.pt300ReqModel = Object.assign({}, _this.pt300ReqModel, queryData);
        }
    },
}
</script>
